import { Component, OnInit } from "@angular/core";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { Router, ActivatedRoute } from "@angular/router";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogThresholdSettingsComponent } from "../dialog-threshold-settings/dialog-threshold-settings.component";
import * as moment from "moment-timezone";
import { CommonModule } from "@angular/common";
import { EboilerBarChartComponent } from "../eboiler-bar-chart/eboiler-bar-chart.component";
import { LineChartComponent } from "../../client/line-chart/line-chart.component";
import { GaugeChartComponent } from "../../client/device-detail-nxt/gauge-chart-component/gauge-chart-component.component";

@Component({
  selector: "app-eboiler-dashboard",
  templateUrl: "./eboiler-dashboard.component.html",
  styleUrls: ["./eboiler-dashboard.component.scss"],
  standalone: true,
  imports: [CommonModule, EboilerBarChartComponent, LineChartComponent, GaugeChartComponent]
})
export class EboilerDashboardComponent implements OnInit {
  public boilerParameterGuage = BaseUrlConstantsService.transformerApi;
  public boilerParameter = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public boiler_parameters_api = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public boilerPramStatusLoading: boolean = false;
  public today: Date;
  // public breadcrumbsArray: any = [
  //   {
  //     page_ref: 'eBoiler-room-devices',
  //     page_title: 'Device Room'
  //   }
  // ];
  public breadcrumbsArray: any = [
    {
      page_ref: "eBoiler-room-devices",
      page_title: "Device Room",
    },
    {
      page_ref: "#",
      page_title: "Boiler Dashboard",
    },
  ];
  public windingtemperatureloading: boolean = true;
  public eboilerParametersGuageData: any[];
  public deviceId: string;
  public gaugeShow: boolean = false;
  public dataGadge: any;
  public Itemsymbol: any;
  public company_name: string;
  public GraphScaleSettingData: any;
  public steamPressureChartData: any = [];
  public firingRateChartData: any = [];
  public waterLevelChartData: any = [];
  public burnerStatusChartData: any = [];
  public commonAlarmChartData: any;
  public tXformerTrendsSurgeRelayData: any;
  public steamPressureChartColors: any[];
  public steamPressureChartOptions: any;
  public steamPressureChartloading: boolean = true;
  public firingRateChartColors: any = [];
  public firingRateChartOptions: any;
  public firingRateloading: boolean = true;
  public waterLevelChartColors: any[];
  public waterLevelChartOptions: any;
  public waterLevelloading: boolean = true;
  public commonAlarmChartColors: any[];
  public commonAlarmChartOptions: any;
  public commonAlarmloading: boolean = true;
  TrendsSurgeRelayLineChartColors: any[];
  TrendsSurgeRelayLineChartOptions: any;
  trendssurgerelayloading: boolean = true;
  public burnerStatusChartColors: any = [];
  public burnerStatusChartOptions: any;
  public burnerStatusloading: boolean = true;
  public clientId: string;
  public userId: string;
  public assetId: string;
  public subsystemId: any;
  public movingAvg: any;
  public subsystem_name: string;
  public loader: boolean = false;
  steammovingAvg: any;
  firingmovingAvg: any;
  watermovingAvg: any;
  updated_at: any;
  public tabName = 'tab-4';
  public tab1: any;
  public tab2: any;
  public tab3: any;
  public tab4: any;
  constructor(
    public service: BackendApiService,
    public router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {
    this.utcTime();
    this.company_name = localStorage.getItem("company_name");
    this.subsystemId = localStorage.getItem("subsystem_id");

    this.activatedRoute.queryParams.subscribe((params) => {
      // console.log(params)
      this.clientId = params["clientId"];
      this.subsystemId = params["subsystemId"];
      this.subsystem_name = params["subsystem_name"];
      this.tabName = params["tabName"],
      this.tab1 = params["tab1"],
      this.tab2 = params["tab2"],
      this.tab3 = params["tab3"],
      this.tab4 = params["tab4"]
    });
  }

  ngOnInit(): void {
    this.subsystemId = localStorage.getItem("subsystem_id");
    if (localStorage.getItem("role") === "ADMIN") {
      this.clientId = localStorage.getItem("admin_client_id");
    } 
    else if(localStorage.getItem("role") === "CLIENT"){
      this.clientId = localStorage.getItem("user_id");
      // this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    }
    else {
      this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    }
    this.getLatestDateAndTime();
    this.getGaugesDataById();
    this.getLineDataByID();
    this.getBarDataByID();
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 :this.tab2,
        tab3 :this.tab3,
        tab4 :this.tab4,
      },
    };
    this.router.navigate([name],navigationExtras);
  }
  getLatestDateAndTime(){
    this.service.getData(this.boiler_parameters_api +"latest-date/" + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000) + "/" + this.subsystemId)
    .then(res => {
      const response = JSON.parse(JSON.stringify(res)).data;
      console.log(response,'sdfsjisiddsi');
      if(response.status === "success"){
        if(response.body.length != 0){
          let testDateUtc = moment.utc(response.body[0].updated_at).toDate();
          this.updated_at = new ConvertDatetimePipe().convertDateTime(
            testDateUtc
          );
          console.log(this.updated_at,'updateday')
        }
      }
    })
  }
  public async getGaugesDataById() {
    this.boilerPramStatusLoading = true;
    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-guage-parameters/" +
          this.clientId +
          "/" +
          this.subsystemId
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          // this.boilerPramStatusLoading = false;
          let response = sensorRes.body;
          console.log(response, "response");
          this.eboilerParametersGuageData = [];
          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              this.dataGadge = response.sensor;

              if (this.dataGadge.length !== 0) {
                let tempArr = [];
                let bottomLab = "";
                for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                  if (
                    JSON.parse(this.dataGadge[mCount].value) === 0 &&
                    this.dataGadge[mCount].needle === false
                  ) {
                    bottomLab = "N/A";
                  } else {
                    bottomLab =
                      JSON.parse(this.dataGadge[mCount].value) < 0
                        ? "N/A"
                        : this.dataGadge[mCount].symbol === "C"
                        ? JSON.parse(this.dataGadge[mCount].value) +
                          " °" +
                          this.dataGadge[mCount].icon
                        : JSON.parse(this.dataGadge[mCount].value) +
                          " " +
                          this.dataGadge[mCount].icon;
                  }

                  this.Itemsymbol = this.dataGadge[mCount].symbol;
                  let needleValueRes;
                  if (this.dataGadge[mCount].symbol === "m/sec²") {
                    needleValueRes =
                      (JSON.parse(this.dataGadge[mCount].value) * 100) /
                      parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                    needleValueRes =
                      (JSON.parse(this.dataGadge[mCount].value) * 100) /
                      parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  } else if (this.dataGadge[mCount].symbol === "deg") {
                    needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  } else {
                    //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                    needleValueRes =
                      (JSON.parse(this.dataGadge[mCount].value) * 100) /
                      parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  }

                  let centerLab =
                    JSON.parse(this.dataGadge[mCount].value) < 0
                      ? "N/A"
                      : JSON.parse(this.dataGadge[mCount].value);
                  let arc_colors =
                    this.dataGadge[mCount].needle === true
                      ? this.dataGadge[mCount].arcColors
                      : ["transparent", "transparent", "transparent"];
                  let range_label =
                    this.dataGadge[mCount].needle === true
                      ? this.dataGadge[mCount].rangelabel
                      : [];
                  let arc_Delimiters =
                    this.dataGadge[mCount].needle === true
                      ? this.dataGadge[mCount].arcDelimiters
                      : [];
                  let value =
                    JSON.parse(this.dataGadge[mCount].value) < 0
                      ? "N/A"
                      : JSON.parse(this.dataGadge[mCount].value);

                  const eboilerParametersData = {
                    // value:value,
                    needleValue: needleValueRes,
                    centralLabel: centerLab,
                    outerNeedle: false,
                    canvasWidth: 220,
                    name: this.dataGadge[mCount].name,
                    key: this.dataGadge[mCount].key,
                    bottomLabel: bottomLab,
                    hasneedle: this.dataGadge[mCount].needle,
                    options: {
                      hasNeedle: this.dataGadge[mCount].needle,
                      needleColor: "black",
                      needleUpdateSpeed: "",
                      arcColors: arc_colors,
                      arcLabels: [] as string[],
                      arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                      rangeLabel: range_label,
                      needleStartValue: 0,
                    },
                  };
                  console.log(arc_Delimiters);
                  if (
                    arc_Delimiters[0] < 100 &&
                    arc_Delimiters[0] > 0 &&
                    arc_Delimiters[1] > 0 &&
                    arc_Delimiters[0] < arc_Delimiters[1] &&
                    arc_Delimiters[1] < 100
                  ) {
                    console.log("Inside if");
                    let max = range_label[1] != null ? range_label[1] : 0;
                    eboilerParametersData.options.arcLabels[0] = Number(
                      this.dataGadge[mCount].arcDelimiters[0]
                    ).toFixed(1);
                    eboilerParametersData.options.arcLabels[1] = Number(
                      this.dataGadge[mCount].arcDelimiters[1]
                    ).toFixed(1);
                    eboilerParametersData.options.arcDelimiters[0] = (
                      ((parseFloat(eboilerParametersData.options.arcLabels[0]) -
                        parseFloat(
                          eboilerParametersData.options.rangeLabel[0]
                        )) /
                        (parseFloat(
                          eboilerParametersData.options.rangeLabel[1]
                        ) -
                          parseFloat(
                            eboilerParametersData.options.rangeLabel[0]
                          ))) *
                      100
                    ).toString();
                    eboilerParametersData.options.arcDelimiters[1] = (
                      ((parseFloat(eboilerParametersData.options.arcLabels[1]) -
                        parseFloat(
                          eboilerParametersData.options.rangeLabel[0]
                        )) /
                        (parseFloat(
                          eboilerParametersData.options.rangeLabel[1]
                        ) -
                          parseFloat(
                            eboilerParametersData.options.rangeLabel[0]
                          ))) *
                      100
                    ).toString();
                    console.log(sensorRes.body,'ensorRes.body')
                    // let velocityG = sensorRes.body.rangeLabels.green;
                    // let velocityY = sensorRes.body.rangeLabels.yellow;
                    // let velocityR = max;
                    eboilerParametersData.options.arcColors[0] = "#72FF13";
                    eboilerParametersData.options.arcColors[1] = "#FAA700";
                    eboilerParametersData.options.arcColors[2] = "#ff2a1b";

                    if (
                      eboilerParametersData.centralLabel <=
                      eboilerParametersData.options.arcLabels[0]
                    ) {
                      // accelerationData.options.centralLabel=
                      eboilerParametersData.options.needleColor = "#72FF13";
                    } else if (
                      eboilerParametersData.centralLabel >
                        eboilerParametersData.options.arcLabels[0] &&
                      eboilerParametersData.centralLabel <=
                        eboilerParametersData.options.arcLabels[1]
                    ) {
                      eboilerParametersData.options.needleColor = "#FAA700";
                    } else {
                      eboilerParametersData.options.needleColor = "#ff2a1b";
                    }

                    this.eboilerParametersGuageData.push(eboilerParametersData);
                    console.log(this.eboilerParametersGuageData);
                    setTimeout(() => {
                      this.windingtemperatureloading = false;
                    }, 3000);

                    this.gaugeShow = true;
                    // this.boilerPramStatusLoading = false;
                    if (this.eboilerParametersGuageData.length >= 1) {
                      // setTimeout(() => {
                      this.boilerPramStatusLoading = false;
                      // }, 100);
                    }
                  }
                }
              }
            }
          }
        }
      });
  }
  public async getLineDataByID() {
    //Trends (Actual and Predicted):: Oil Temperature Data (Line Chart).
    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-trends-steam-pressure/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((sRes) => {
        this.steamPressureChartloading = true;
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.steamPressureChartData = [];
          this.steamPressureChartColors = [];

          this.steamPressureChartOptions = response.name;
          console.log(this.steamPressureChartOptions);

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.steamPressureChartData.push(barData);
              this.steammovingAvg = response.movingAvg;
            }
            if (Object.keys(response.rangeLabels).length != 0) {
              this.steamPressureChartColors.push(response.rangeLabels);
            }
            console.log(this.steamPressureChartData);
            if (
              this.steamPressureChartData.length >= 1 ||
              this.steamPressureChartColors.length > 0
            ) {
              setTimeout(() => {
                this.steamPressureChartloading = false;
              }, 1000);
            }
          }
        }
      });

    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-trends-firing-rate/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((sRes) => {
        this.firingRateloading = true;
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.firingRateChartData = [];
          this.firingRateChartColors = [];

          this.firingRateChartOptions = response.name;
          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.firingRateChartData.push(barData);
              this.firingmovingAvg = response.movingAvg;
            }

            if (response.rangeLabels.length != 0) {
              this.firingRateChartColors.push(response.rangeLabels);
            }

            if (
              this.firingRateChartData.length >= 1 ||
              this.firingRateChartColors.length > 0
            ) {
              setTimeout(() => {
                this.firingRateloading = false;
              }, 1000);
            }
          }
        }
      });

    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-trends-water-level/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((sRes) => {
        this.waterLevelloading = true;
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.waterLevelChartData = [];
          this.waterLevelChartColors = [];

          this.waterLevelChartOptions = response.name;
          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.waterLevelChartData.push(barData);
              this.watermovingAvg = response.movingAvg;
            }

            if (response.rangeLabels.length != 0) {
              this.waterLevelChartColors.push(response.rangeLabels);
            }

            if (
              this.waterLevelChartData.length >= 1 ||
              this.waterLevelChartColors.length > 0
            ) {
              setTimeout(() => {
                this.waterLevelloading = false;
              }, 1000);
            }
          }
        }
      });
  }
  public async getBarDataByID() {
    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-trends-burner-status/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;
        if (sensorRes.status === "success") {
          if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
            let response = sensorRes.body;
            this.burnerStatusChartData = [];
            this.burnerStatusChartColors = [];

            this.burnerStatusChartOptions = response.name;
            if (response.sensor != undefined) {
              if (response.sensor.length != 0) {
                let barData = response.sensor;
                this.burnerStatusChartData.push(barData);
              }

              if (response.rangeLabels.length != 0) {
                this.burnerStatusChartColors.push(response.rangeLabels);
              }

              if (
                this.burnerStatusChartData.length >= 1 ||
                this.burnerStatusChartColors.length > 0
              ) {
                setTimeout(() => {
                  this.burnerStatusloading = false;
                }, 1000);
              }
            }
          }
        } else {
          this.burnerStatusChartData = [];
          this.burnerStatusChartData = [];
          this.burnerStatusChartColors = [];
        }
      });

    this.service
      .getDataWithQuery(
        this.boilerParameter +
          "get-trends-common-alarm/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.commonAlarmChartData = [];
          this.commonAlarmChartColors = [];

          this.commonAlarmChartOptions = response.name;
          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.commonAlarmChartData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.commonAlarmChartColors.push(response.rangeLabels);
            }

            if (
              this.commonAlarmChartData.length >= 1 ||
              this.commonAlarmChartColors.length > 0
            ) {
              setTimeout(() => {
                this.commonAlarmloading = false;
              }, 1000);
            }
          }
        }
      });
  }
  getMoreParameter() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        subsystem_name: this.subsystem_name,
        pageRef: "Boiler-Dashboard",
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 : this.tab2,
        tab3 : this.tab3,
        tab4 :this.tab4,
      },
    };
    this.router.navigate(["/eboiler-parameters"], navigationExtras);
  }
  openEboilerThresholdSetting(metric_type: string): void {
    this.loader = true;

    this.getExformerGraphScaleSettingsDataByID(metric_type)
      .then((data: any) => {
        //set data into GraphScaleSettingData variable.
        this.GraphScaleSettingData = [];
        let response = data.body;
        // this.GraphScaleSettingData.push({metric_type:metric_type, threshold_1:response[0].threshold_1,threshold_2:response[0].threshold_2,threshold_3:response[0].threshold_3,max_value:response[0].max_value,base_value:response[0].base_value});
        //Open Dialog Box.
        this.GraphScaleSettingData = response;
        this.loader = false;
        const dialogRef = this.dialog.open(DialogThresholdSettingsComponent, {
          width: "800px",
          data: {
            type: "allMertrics",
            dataAll: this.GraphScaleSettingData,
          },
        });

        //Closed Dialog box
        dialogRef.afterClosed().subscribe((updatedSettings) => {
          if (updatedSettings) {
            this.saveSettings(updatedSettings);
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.loader = false;
        // Handle error here
      });
  }
  saveSettings(updatedSettings: any): void {
    // Implement saving logic using DataService
    // Example:
    this.service
      .putData(
        this.boilerParameter + "metrics/" + this.subsystemId,
        updatedSettings
      )
      .then(
        (res) => {
          let response = JSON.parse(JSON.stringify(res)).data;
          if (response.status === "success") {
            this.getGaugesDataById();
            this.getLineDataByID();
          }
        },
        (error) => {
          console.error("Error saving settings:", error);
        }
      );
  }
  public async getExformerGraphScaleSettingsDataByID(
    metric_type: string
  ): Promise<any> {
    try {
      const sensorRes = await this.service
        .getDataWithQuery(
          `${this.boilerParameter}metrics/parameters/${this.clientId}/${this.subsystemId}?metric_type=${metric_type}`
        )
        .then((res) => {
          return res;
        });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;

      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error("No data found in sensor response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
}
